import { APIClient } from "./axiosClient";

export class OrderApi {
  static fetchOrder(orderId) {
    return APIClient(`/order/getOrder?orderId=${orderId}`);
  }

  static updateOrderStatus({ id, orderStatus }) {
    return APIClient('/order/updateOrderStatus', { id, orderStatus }, { requestType: 'post' });
  }

  static fetchOrders(payload) {
    return APIClient('/order/getOrders', payload, { requestType: 'post' });
  }
} 